export default __webpack_public_path__ + "static/media/home-img-3.bdb680c6.png";